import { ITheme, IconButton, SvgIcon, useTheme } from '@mui/material';
import React from 'react';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { addFavorites, deleteFavorites } from '../../store/actions/libraryOfFunds';
import { useTranslation } from 'react-i18next';
import { ReactComponent as starIcon } from '../../assets/star.svg';
import { ReactComponent as starFilledIcon } from '../../assets/star_filled.svg';

export interface IFavoriteFundButtonProps{
    fundId: number;
}

const FavoriteFundButton: React.FC<IFavoriteFundButtonProps> = ({ fundId}) => {
    const dispatch = useAppDispatch();
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();
    const favorites = useAppSelector(state => state.libraryOfFundsReducer.favorites);
    if (favorites === undefined){
        return <></>;
    } 
    const isSelected = favorites.indexOf(fundId) !== -1;

    const onFavoriteClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        if (isSelected){
            dispatch(deleteFavorites(fundId));
        }else{
            dispatch(addFavorites(fundId));
        }
    }
    return <IconButton size='small' onClick={onFavoriteClick} aria-label={isSelected ? t('A11yRemoveFromFavorite') : t('A11yAddToFavorite')}>
        {isSelected ?
            <SvgIcon component={starFilledIcon} inheritViewBox sx={{ color: theme.palette.primary.dark, width: "16px", height: "16px" }} />
            // <StarIcon fontSize='small' sx={{ color: theme.palette.primary.dark }} />
            :
            <SvgIcon component={starIcon} inheritViewBox sx={{ color: theme.palette.primary.dark, width: "16px", height: "16px" }} />
            // <StarOutlineIcon fontSize='small' sx={{ color: theme.palette.text.primary}} />
            }
    </IconButton>
}

export default FavoriteFundButton;